module.exports = __webpack_public_path__ + "img/slideshow-carnets-02-prypiat.704f06d9.png";